<template>
  <base-sidebar
    :model-value="isOpen"
    :temporary="temporary"
    :width="width"
    class="pa-2"
    v-bind="$attrs"
    @update:model-value="setOpen"
  >
    <v-card-title class="headline">{{ title }}</v-card-title>

    <v-card-subtitle>{{ subtitle }}</v-card-subtitle>

    <v-divider class="my-2"></v-divider>

    <v-container>
      <slot />
    </v-container>

    <v-divider class="my-2"></v-divider>

    <v-card-actions>
      <base-sidebar-btn
        v-if="(save != null)"
        :label="saveLabel"
        :icon="saveIcon"
        :btn-class="!$store.state.isDarkMode ? 'mr-4 blue' : 'mr-4 blue-darken-3'"
        icon-color="white"
        @click="save()"
      ></base-sidebar-btn>
      <base-sidebar-btn
        icon="mdi-close"
        :btn-class="!$store.state.isDarkMode ? 'grey-lighten-5' : 'grey-darken-4'"
        :icon-color="!$store.state.isDarkMode ? 'grey' : 'white'"
        @click="setOpen(false)"
      ></base-sidebar-btn>
      <slot name="actions" />
    </v-card-actions>
  </base-sidebar>
</template>

<script>
export default {
  name: 'BaseSidebarEditor',

  inheritAttrs: false,

  props: {
    modelValue: {},
    value: {},
    width: {
      type: [Number, String],
      default: 350,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    save: {
      type: Function,
      default: null,
    },
    saveLabel: {
      type: String,
      default: 'Save',
    },
    saveIcon: {
      type: String,
      default: 'mdi-content-save',
    },
    temporary: {
      type: Boolean,
      default: true,
    },
  },

  emits: ['update:modelValue', 'input'],

  computed: {
    isOpen() {
      return !!(this.modelValue ?? this.value);
    },
  },

  methods: {
    setOpen(open) {
      this.$emit('update:modelValue', open);
      this.$emit('input', open);
    },
  },
};
</script>
